module.exports = __webpack_public_path__ + "assets/2f4c7169ef00155db262f93a0475bc55.mp4";